<template lang="pug">
    aside-modal(
        ref="modal"
        id="subsidy-recovery-import"
        width="w-xxl"
        :loading="uploading"
        @modal-hidden="reset"
    )
        span(slot="header-text") Import Subsidy Recovery

        div.p-a(slot="body")
            p.m-b-md
                | Upload a CSV file with the following columns: Outlet Code, Receipt Number.
            a.btn.btn-default.m-b-md(:href="sampleUrl") Download sample CSV file

            .form-group
                label.control-label Select CSV File
                input.form-control(
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    @change="onFileChange"
                )

            div.alert.alert-danger(v-if="importErrors.length")
                ul.m-b-0
                    li(v-for="(error, idx) in importErrors" :key="`import_err_${idx}`") {{ error }}

        span(slot="footer")
            button.btn.btn-fw.primary(
                @click="submit"
                :disabled="uploading || !selectedFile"
            ) Upload
</template>

<script>
export default {
    data() {
        return {
            selectedFile: null,
            uploading: false,
            importErrors: [],
        };
    },

    computed: {
        sampleUrl() {
            const route =
                typeof Laroute !== 'undefined' &&
                Laroute.route('franchise.report.subsidy-recovery.sample');

            return route || '/franchise/report/subsidy-recovery/sample';
        },

        importUrl() {
            const route =
                typeof Laroute !== 'undefined' &&
                Laroute.route('franchise.report.subsidy-recovery.import');

            return route || '/franchise/report/subsidy-recovery/import';
        },
    },

    methods: {
        onFileChange(event) {
            const file = event.target.files[0];
            this.importErrors = [];

            if (!file) {
                this.selectedFile = null;
                return;
            }

            const isCsv = file.name.toLowerCase().endsWith('.csv');

            if (!isCsv) {
                this.selectedFile = null;
                event.target.value = '';
                this.importErrors = ['Only CSV files are allowed.'];
                return;
            }

            this.selectedFile = file;
        },

        async submit() {
            if (!this.selectedFile || this.uploading) {
                return;
            }

            const formData = new FormData();
            formData.append('file', this.selectedFile);

            this.uploading = true;
            this.importErrors = [];

            try {
                const { data } = await axios.post(this.importUrl, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });

                toastr.success(data.message || 'Import completed.');
                this.$emit('import-success');
                this.close();
            } catch (error) {
                const response = error.response || {};
                const message = response.data && response.data.message;
                const errors = response.data && response.data.errors;

                toastr.error(message || 'Import failed.');

                if (Array.isArray(errors)) {
                    this.importErrors = errors;
                } else if (errors && typeof errors === 'object') {
                    this.importErrors = Object.values(errors).flat();
                }
            } finally {
                this.uploading = false;
            }
        },

        reset() {
            this.selectedFile = null;
            this.uploading = false;
            this.importErrors = [];

            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },

        open() {
            this.$refs.modal.$emit('show');
        },

        close() {
            this.$refs.modal.$emit('hide');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/subsidy-recovery/subsidy-recovery-import-modal.vue